import React, { useRef, useEffect, Children } from 'react';
import Swipe from './swipe';

const getNumberOfGapItem = numberOfVisibleItems =>
  Math.floor(numberOfVisibleItems / 2);

export default function WheelPicker ({
  children,
  value,
  onChange,
  numberOfVisibleItems = 5,
  ...rest
}) {
  const itemHeight = 40;
  const innerContainerRef = useRef();
  const outerContainerRef = useRef();

  const freshEvents = useRef({});

  const setTranslate = newY => {
    innerContainerRef.current.style.transform = `translateY(${newY}px)`;
  };

  const getTranslate = () =>
    parseInt(
      innerContainerRef.current.style.transform
        .replace('translateY(', '')
        .replace('px)', ''),
      10,
    ) || 0;

  const handleValueChanges = value => {
    try {
      Children.forEach(children, (child, index) => {
        if (child.props.content === value) {
          [...innerContainerRef.current.children].forEach(
            (childEl, indexEl) => {
              if (index === indexEl) {
                childEl.setAttribute('data-wheel-choose-selected', 'selected');
                childEl.setAttribute('aria-selected', 'true');
                setTranslate(
                  -1 * childEl.offsetTop +
                    itemHeight * getNumberOfGapItem(numberOfVisibleItems),
                );
              } else {
                childEl.removeAttribute('data-wheel-choose-selected');
                childEl.setAttribute('aria-selected', 'false');
              }
            },
          );
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  freshEvents.current.updateValueBasedOnY = () => {
    const childrenArr = [...innerContainerRef.current.children];
    let currentOffsetTop =
      getTranslate() - itemHeight * getNumberOfGapItem(numberOfVisibleItems);
    const min = -1 * (itemHeight * (children.length - 1));
    const max = 0;

    if (currentOffsetTop < min) {
      currentOffsetTop = min;
    } else if (currentOffsetTop > max) {
      currentOffsetTop = max;
    }
    currentOffsetTop = Math.abs(currentOffsetTop);

    const closestValue = childrenArr.reduce((prev, curr) =>
      Math.abs(curr.offsetTop - currentOffsetTop) <
      Math.abs(prev.offsetTop - currentOffsetTop)
        ? curr
        : prev,
    );

    const index = childrenArr.indexOf(closestValue);

    const selectedValue = Children.map(children, x => x)[index].props.content;

    onChange(selectedValue);

    const shouldMoveToSelectedItem = () => selectedValue === value;

    if (shouldMoveToSelectedItem) {
      handleValueChanges(selectedValue);
    }
  };

  useEffect(() => {
    const swipe = Swipe();
    swipe.setElement(outerContainerRef.current);
    swipe.on();

    let y = 0;
    swipe.beforeSwipe(() => {
      innerContainerRef.current.style.transitionDuration = '0s';
      y = getTranslate();
    });
    swipe.whileSwipe((_pos, diff) => {
      setTranslate(y + diff.y);
    });
    swipe.afterSwipe(() =>
      {
        innerContainerRef.current.style.transitionDuration = null;
        freshEvents.current.updateValueBasedOnY();
      },
    );

    return () => {
      swipe.off();
    };
  }, []);

  useEffect(() => {
    handleValueChanges(value);
  });

  return (
    <div
      className='wheel-picker'
      ref={outerContainerRef}
      {...rest}
    >
      <div className='inner' ref={innerContainerRef} role='listbox'>
        {children}
      </div>
      <div className='top-shadow' />
      <div className='bottom-shadow' />
      <div className='selected-border' />
    </div>
  );
};
